import {positionEventContents} from "./positionEventContents";
import {checkIfAlreadyProsted} from "../../prost/checkIfAlreadyProsted";
import {checkIfAlreadyFavourites} from "../../favourites/checkIfAlreadyFavourites";

export function loadEventContent(ids, furtherParams, shopUserId, lazyLoadOnThisPage) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_event_entries",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            positionEventContents(output, lazyLoadOnThisPage);
            checkIfAlreadyProsted(ids, "", shopUserId, false, 6);
            checkIfAlreadyFavourites(ids, shopUserId, 6);
        }
    });
}